import React, { forwardRef } from 'react';
import tw, { styled } from 'twin.macro';

interface ComponentProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  disabled?: boolean;
  rows?: number;
  fullWidth?: boolean;
  hasError?: boolean;
}

const Textarea = styled.textarea<ComponentProps>`
  ${tw`appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm`};
  ${(props) => (props.fullWidth ? tw`w-full` : tw`w-3/4`)}
  ${(props) => (props.disabled ? tw`bg-gray-100 !text-gray-500` : '')}
  ${(props) => (props.hasError ? tw`text-red-900 border-red-300 placeholder:text-red-300 focus:ring-red-500` : '')}
`;

const StyledTextarea = forwardRef<HTMLTextAreaElement, ComponentProps>(({ rows, ...props }, ref) => {
  return <Textarea rows={rows} ref={ref} {...props} />;
});

StyledTextarea.displayName = 'StyledTextarea';

StyledTextarea.defaultProps = {
  disabled: false,
  rows: 3,
  fullWidth: true,
  hasError: false,
};

export default StyledTextarea;
